import './App.css';
import SmoothScroll from './SmoothScroll';


function App() {
  return (
    <div className='motherdiv'>

    <SmoothScroll />
    </div>
  );
}

export default App;
